export const paths = Object.freeze({
    auth: {
        login: "/login",
        register: "/register",
        forgotPassword: "/forgot-password",
        verifyEmail: "/verify-email",
        createPassword: "/create-password",
        selectCountry: "/select-country",
        serviceAgreement: "/service-agreement",
        checkEmailProceed: "/check-email-proceed",
    },
    dashboard: "/",
    registerDetails: "/register-details",
    registerInstallations: "/register-installations",
    registerProviders: "/register-providers",
    updatePayment: "/update-payment",
    jobs: "/jobs",
    jobPayment: "/jobs/:id/payment",
    jobDetails: "/jobs/:title",
    messaging: "/messaging",
    schedule: "/schedule",
    reschedule: "/reschedule/:title",
    vehicles: "/vehicles",
    notifications: "/notifications",
    settings: {
        root: "/settings",
        companyInfo: "/settings/company-info",
        credits: "/settings/credits",
        security: "/settings/security",
        vehicles: "/settings/vehicles",
        locations: "/settings/locations",
        paymentMethod: "/settings/payment-method",
        faq: "/settings/faq",
        terms: "/settings/terms",
        privacyPolicy: "/settings/privacy-policy",
    },
    paymentResult: "/payment-result",
});